import { type ReactNode } from 'react';
import { PageLayout } from './PageLayout';
import { PageHeader, type TabItem } from './PageHeader';

export interface ListPageLayoutProps {
  title: string;
  subtitle?: string;
  icon?: ReactNode;
  actions?: ReactNode;
  tabs?: TabItem[];
  activeTab?: string;
  onTabChange?: (tabId: string) => void;
  toolbar?: ReactNode;
  children: ReactNode;
  contentBackground?: string;
}

export function ListPageLayout({
  title,
  subtitle,
  icon,
  actions,
  tabs,
  activeTab,
  onTabChange,
  toolbar,
  children,
  contentBackground,
}: ListPageLayoutProps) {
  return (
    <PageLayout
      variant="constrained"
      contentBackground={contentBackground}
      header={
        <PageHeader
          title={title}
          subtitle={subtitle}
          icon={icon}
          actions={actions}
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={onTabChange}
          borderStyle="bottom"
        />
      }
    >
      <div className="py-6 animate-fade-in">
        {toolbar && <div className="mb-4">{toolbar}</div>}
        {children}
      </div>
    </PageLayout>
  );
}

export default ListPageLayout;
